import {Component, inject, OnInit} from '@angular/core';
import {PositionsService} from "../../../app/api/api/positions.service";
import {ModelsPosition} from "../../../app/api/model/models";
import {ButtonModule} from "primeng/button";
import {TableModule} from "primeng/table";
import {PaginatorModule} from "primeng/paginator";
import {RippleModule} from "primeng/ripple";
import {ToolbarModule} from "primeng/toolbar";
import {InputTextModule} from "primeng/inputtext";
import {ConfirmationService, MessageService} from "primeng/api";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {ToastModule} from "primeng/toast";
import {HrPositionsForm} from './hr.positions.form';
import {Card} from 'primeng/card';

interface UserPosition {
  id: number;
  name: string;
  requirements: string;
  scheduling_display_name: string;
  day_limit: number;
  week_limit: number;
}

@Component({
  selector: 'app-hr-positions',
  template: `
    <p-toast></p-toast>
    <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
    <app-hr-position-form
      [visible]="positionDialog" [position]="position" (onSave)="savePosition($event)"
      (onCancel)="hideDialog()"></app-hr-position-form>

    <p-card>
      @if(false) {
        <div class="flex justify-between mb-4">
          <div>
            <p-button
              severity="success"
              label="Create"
              icon="pi pi-plus"
              (click)="openNew()"/>
          </div>
          <div></div>
        </div>
      }
      <p-table
        #dt
        [value]="positions"
        [rows]="10"
        [paginator]="true"
        [rowsPerPageOptions]="[10, 20, 30]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowHover]="true"
        dataKey="id"
        tableStyleClass="mb-4">
        <!--      <ng-template pTemplate="caption">-->
        <!--        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">-->
        <!--          <h5 class="m-0">Manage Positions</h5>-->
        <!--          <span class="block mt-2 md:mt-0 p-input-icon-left">-->
        <!--            <i class="pi pi-search"></i>-->
        <!--            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search..." />-->
        <!--          </span>-->
        <!--        </div>-->
        <!--      </ng-template>-->
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="name">Name
              <p-sortIcon field="name"></p-sortIcon>
            </th>
            <!--          <th pSortableColumn="scheduling_display_name">Scheduling Display Name <p-sortIcon field="scheduling_display_name"></p-sortIcon></th>-->
            <!--          <th pSortableColumn="day_limit">Day Limit <p-sortIcon field="day_limit"></p-sortIcon></th>-->
            <!--          <th pSortableColumn="week_limit">Week Limit <p-sortIcon field="week_limit"></p-sortIcon></th>-->
<!--            <th></th>-->
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-position>
          <tr>
            <td>{{ position.name }}</td>
            <!--          <td>{{ position.scheduling_display_name }}</td>-->
            <!--          <td>{{ position.day_limit }}</td>-->
            <!--          <td>{{ position.week_limit }}</td>-->
<!--            <td class="w-1">-->
<!--              <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"-->
<!--                      (click)="editPosition(position)"></button>-->
<!--            </td>-->
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  `,
  standalone: true,
  imports: [
    ButtonModule,
    TableModule,
    PaginatorModule,
    RippleModule,
    ToolbarModule,
    InputTextModule,
    HrPositionsForm,
    ConfirmDialogModule,
    ToastModule,
    Card
  ],
  providers: [MessageService, ConfirmationService]
})
export class HrPositionsIndex implements OnInit {
  private positionsApi = inject(PositionsService);
  private messageService = inject(MessageService);

  positions: ModelsPosition[] = [];
  positionDialog = false;
  position: ModelsPosition = {} as ModelsPosition;

  ngOnInit() {
    this.positionsApi.apiPositionsGet().subscribe((r: any) => {
      if (r.data) {
        this.positions = r.data;
      }
    });
  }

  openNew() {
    this.position = {} as ModelsPosition;
    this.positionDialog = true;
  }

  hideDialog() {
    this.positionDialog = false;
  }

  savePosition(position: ModelsPosition) {
    const isNew = !position.id;
    const action = isNew ? 'create' : 'update';
    const variables = {
      action,
      input: {
        id: position.id,
        name: position.name
      }
    };
    // this.gql.query(
    //   //language=GraphQL
    //   `
    //     mutation position($action: MutationAction!, $input: UserPositionInput!) {
    //       hr_position(action: $action, input: $input) {
    //         id
    //         name
    //         requirements
    //         scheduling_display_name
    //         day_limit
    //         week_limit
    //       }
    //     }
    //   `,
    //   variables
    // ).subscribe((r: IGQLResponse<{ hr_position: UserPosition }>) => {
    //   const savedPosition = r.data.hr_position;
    //   if (isNew) {
    //     this.positions.push(savedPosition);
    //   } else {
    //     this.positions[this.findIndexById(position.id)] = savedPosition;
    //   }
    //   this.positions = [...this.positions];
    //   this.positionDialog = false;
    //   this.messageService.add({severity: 'success', summary: 'Successful', detail: 'Position Saved', life: 3000});
    // });
  }

  findIndexById(id: number): number {
    let index = -1;
    for (let i = 0; i < this.positions.length; i++) {
      if (this.positions[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  }

  editPosition(position: ModelsPosition) {
    this.position = {...position};
    this.positionDialog = true;
  }
}
